import React from 'react';
import PropTypes from 'prop-types';
import {withRouter} from '../../helpers/WithRouter';
import DataLoader from '../../components/DataLoader/DataLoader';
import DataError from '../../components/DataError/DataError';
import ProductTitle from '../../components/ProductTitle/ProductTitle';
import ProductBoxSlider from '../../components/ProductBoxSlider/ProductBoxSlider';
import ImageList from '../../components/ImageList/ImageList';
import ImageViewer from '../../components/ImageViewer/ImageViewer';
import ModelViewer from '../../components/ModelViewer/ModelViewer';
import IconButtonsGrid from '../../components/IconButtonsGrid/IconButtonsGrid';
import ARModal from '../../components/ARModal/ARModal';
import ProductDetailsSidebar from '../../components/ProductDetailsSidebar/ProductDetailsSidebar';
import ProductVariantsSidebar from '../../components/ProductVariantsSidebar/ProductVariantsSidebar';
import ExternalProductModal from '../../components/ExternalProductModal/ExternalProductModal';
import OnRequestProductModal from '../../components/OnRequestProductModal/OnRequestProductModal';
import NoStockModal from '../../components/NoStockModal/NoStockModal';
import ShareModal from '../../components/ShareModal/ShareModal';
import Modal from "../../components/Modal/Modal";
import NotFound from '../NotFound/NotFound';
import Navigation from '../../config/Navigation';
import Viewport from '../../helpers/Viewport';
import Debug from '../../helpers/Debug';
import Activity from '../../helpers/Activity';
import URLParams from '../../helpers/URLParams';
import WebServices from '../../helpers/WebServices';
import {Catalog as _Catalog} from '../../models/Catalog';
import {Product as _Product} from '../../models/Product';
import {ShoppingCartItem as _ShoppingCartItem} from '../../models/ShoppingCart';
import CatalogSearch from '../../helpers/CatalogSearch';
import {firestore, getCollectionPath} from '../../config/Firebase';
import {doc, onSnapshot} from 'firebase/firestore';
import {productConverter} from '../../models/Product';
import hideBlueIcon from './images/fullscreen-blue.png';
import showWhiteIcon from './images/fullscreen-white.png';
import arBlueIcon from './images/ar-blue.svg';
import arWhiteIcon from './images/ar-white.svg';
import rulerBlueIcon from './images/ruler-blue.svg';
import rulerWhiteIcon from './images/ruler-white.svg';
import resetBlueIcon from './images/reset-blue.png';
import resetWhiteIcon from './images/reset-white.png';
import detailsBlueIcon from './images/details-blue.svg';
import detailsWhiteIcon from './images/details-white.svg';
import shareBlueIcon from './images/share-blue.svg';
import shareWhiteIcon from './images/share-white.svg';
import cartWhiteIcon from './images/cart-white.svg';
import cartBlueIcon from './images/cart-blue.svg';
import squaresWhiteIcon from './images/squares-white.svg';
import squaresBlueIcon from './images/squares-blue.svg';
import caretIcon from './images/caret.png';
import {PLP_3D_DEFAULT_CONFIG, PLP_3D_FULLSCREEN_CONFIG} from '../../config/App';
import './Product.css';

class Product extends React.Component {
    constructor(props) {
        super(props);
        const parameters = URLParams.getParams();
        const variantId = parameters.get('variantId');
        const queryId = parameters.get('queryId');
        this.state = {
            queryId: queryId || undefined,
            productId: this.props.params.productId,
            variantId: variantId || undefined,
            isLoadingProduct: true,
            productLoaded: false,
            product: undefined,
            similar: [],
            maxSimilar: 10,
            listMode: 'images',
            listModePulseEffect: false,
            selectedImageIndex: '0',
            hideDetails: false,
            showArModal: false,
            showSize: false,
            showProductDetails: false,
            showShareModal: false,
            showCart: false,
            showActions: false,
            showVariants: false,
            selectedVariant: undefined,
            showExternalProductModal: false,
            showOnRequestProductModal: false,
            showNoStockModal: false,
            notFound: false,
            errorMessage: undefined,
            errorActionLabel: undefined,
            errorAction: undefined
        };
        this._isMounted = true;
        this._iframeRef = React.createRef();
        this._unsubscribeProduct = undefined;
    };

    changeState = (newState, callback) => {
        if (this._isMounted) {
            this.setState(newState, () => {
                if (callback) callback();
            });
        }
    };

    componentDidMount() {
        this._isMounted = true;
        this.getProduct();
        this.setMessageReceiverListener();
    };

    componentDidUpdate(prevProps, prevState, _snapshot) {
        const needsReload = _Catalog.catalogChanged(prevProps.catalog, this.props.catalog);
        if (needsReload) Navigation.reload();
        if (prevState.product && this.state.product) {
            if (prevState.product.hasStock() && !this.state.product.hasStock() && !this.props.showCheckoutModal) {
                this.openNoStockModal();
                this.closeArModal();
                this.closeShareModal();
                this.closeExternalProductModal();
                this.closeOnRequestProductModal();
            }
            if (!prevState.product.hasStock() &&  this.state.product.hasStock()) {
                const selectedVariant = this.getFirstValidVariant(this.state.product);
                this.changeState({selectedVariant: selectedVariant ? selectedVariant.id : undefined, showVariants: !!selectedVariant}, this.closeNoStockModal);
            }
        }
    };

    componentWillUnmount() {
        this._isMounted = false;
        this.unsubscribe();
        this.removeMessageReceiverListener();
    };

    setMessageReceiverListener = () => {
        window.addEventListener('message', this.onMessageReceived);
    };

    removeMessageReceiverListener = () => {
        window.removeEventListener('message', this.onMessageReceived);
    };

    onMessageReceived = (event) => {
        const message = event.data;
        if (message && message.data && message.from && message.from === 'model-viewer') {
            switch (message.type) {
                case 'model-loaded':
                    // Implement if needed.
                    break;
            }
        }
    };

    getProduct = () => {
        const _path = getCollectionPath(this.props.client, 'items');
        const _doc = doc(firestore, _path, this.state.productId).withConverter(productConverter);
        this._unsubscribeProduct = onSnapshot(_doc, (_document) => {
            if (_document.exists()) {
                const {catalog} = this.props;
                const product = _document.data();
                const inCatalog = product.inCatalog(catalog);
                if (!inCatalog) this.onLoadError(true, undefined, 'Volver', this.back);
                else {
                    const {isLoadingProduct, productLoaded} = this.state;
                    const has3dModel = product.has3dModel;
                    const selectedVariant = this.getFirstValidVariant(product);
                    const isFirstLoad = isLoadingProduct && !productLoaded;
                    let newState = {product: product};
                    if (!isFirstLoad) {
                        newState.selectedVariant = selectedVariant ? selectedVariant.id : undefined;
                        newState.showVariants = !!selectedVariant;
                    }
                    this.changeState(newState, () => {
                        this.getSimilar();
                        if (isFirstLoad) {
                            this.changeState({isLoadingProduct: false, productLoaded: true, selectedVariant: selectedVariant ? selectedVariant.id : undefined, showVariants: !!selectedVariant, selectedImageIndex: has3dModel ? '3D' : '0'});
                            if (!product.hasStock()) this.openNoStockModal();
                            this.updateProduct();
                        }
                    });
                }
            } else this.onLoadError(true, undefined, 'Volver', this.back);
        }, (error) => {
            Debug.printToLog('error', error);
            this.onLoadError(false, 'Se ha producido un error al cargar la información del producto', 'Reintentar', Navigation.reload);
        });
    };

    getSimilar = () => {
        const {client, catalog} = this.props;
        const {product} = this.state;
        CatalogSearch.getRecommendedItems(client, catalog, product)
            .then((similar) => {
                this.changeState({similar: _Product.filterValidProducts(similar)});
            })
            .catch(() => {
                this.changeState({similar: []});
            });
    };

    getFilteredSimilar = () => {
        const {similar, maxSimilar} = this.state;
        return similar.slice(0, maxSimilar);
    };

    getFirstValidVariant = (product) => {
        let selectedVariant = undefined;
        const validVariants = _Product.filterValidProducts(product.variants);
        if (validVariants.length > 0) {
            const match = validVariants.find((variant) => variant.id === this.state.variantId);
            selectedVariant = match ? match : validVariants[0];
        }
        return selectedVariant;
    };

    updateProduct = () => {
        WebServices.startProductExtraction(this.props.client, [{id: this.state.productId, parent: undefined}]);
    };

    unsubscribe = () => {
        if (this._unsubscribeProduct) this._unsubscribeProduct();
    };

    loadingData = () => {
        return this.state.isLoadingProduct;
    };

    dataLoaded = () => {
        return this.state.productLoaded;
    };

    onLoadError = (notFound, message, actionLabel, action) => {
        this.changeState({
            isLoadingProduct: false,
            productLoaded: false,
            product: undefined,
            notFound: notFound,
            errorMessage: message,
            errorActionLabel: actionLabel,
            errorAction: action
        });
    };

    back = () => {
        this.props.navigate(-1);
    };

    getIconButtons = () => {
        const {style, inSmallMode} = this.props;
        const {product, hideDetails} = this.state;
        const displayStyle = style && style['product'] && style['product']['actionButtons'] && style['product']['actionButtons']['display'] ? style['product']['actionButtons']['display'] : {};
        const arStyle = style && style['product'] && style['product']['actionButtons'] && style['product']['actionButtons']['ar'] ? style['product']['actionButtons']['ar'] : {};
        const rulerStyle = style && style['product'] && style['product']['actionButtons'] && style['product']['actionButtons']['ruler'] ? style['product']['actionButtons']['ruler'] : {};
        const resetStyle = style && style['product'] && style['product']['actionButtons'] && style['product']['actionButtons']['reset'] ? style['product']['actionButtons']['reset'] : {};
        const shareStyle = style && style['product'] && style['product']['actionButtons'] && style['product']['actionButtons']['share'] ? style['product']['actionButtons']['share'] : {};
        const detailsStyle = style && style['product'] && style['product']['actionButtons'] && style['product']['actionButtons']['details'] ? style['product']['actionButtons']['details'] : {};
        const cartStyle = style && style['product'] && style['product']['actionButtons'] && style['product']['actionButtons']['cart'] ? style['product']['actionButtons']['cart'] : {};
        const variantsStyle = style && style['product'] && style['product']['actionButtons'] && style['product']['actionButtons']['variants'] ? style['product']['actionButtons']['variants'] : {};
        const visibleFeatures = this.state.product.visibleFeatures();
        let buttons = [];
        const showDisplayButton  = true;
        const showArButton       = this.state.selectedImageIndex === '3D' && Boolean(this.state.product.viewItArUrl);
        const showRulerButton    = this.state.selectedImageIndex === '3D' && Boolean(this.state.product.viewItSceneUrl);
        const showResetButton    = this.state.selectedImageIndex === '3D' && Boolean(this.state.product.viewItSceneUrl);
        const showShareButton    = this.state.selectedImageIndex === '3D' && Boolean(this.state.product.viewItSceneUrl);
        const hideDetailsButton  = Boolean(visibleFeatures && visibleFeatures.length > 0); // If in the future the long description is necessary, add it to the condition.
        const showActionButton   = true;
        const showVariantsButton = this.state.product.variants && this.state.product.variants.length > 0;
        const showButtons        = inSmallMode ? true : !hideDetails;
        const displayButton = {
            id: 'display-button',
            icon: displayStyle['inactiveIcon'] || hideBlueIcon,
            label: 'Activar Fullscreen',
            labelColor: displayStyle['labelColor'],
            backgroundColor: displayStyle['backgroundColor'],
            action: this.toggleDetails,
            active: this.state.hideDetails,
            activeIcon: displayStyle['activeIcon'] || showWhiteIcon,
            activeLabel: 'Desactivar Fullscreen',
            activeLabelColor: displayStyle['activeLabelColor'],
            activeBackgroundColor: displayStyle['activeBackgroundColor'],
            stopPropagation: false,
            showPulseEffect: false,
            showPulseWhenActive: true,
            visible: true,
            disabled: false
        };
        const arButton = {
            id: 'ar-button',
            icon: arStyle['inactiveIcon'] || arBlueIcon,
            label: 'Ver en tu espacio',
            labelColor: arStyle['labelColor'],
            backgroundColor: arStyle['backgroundColor'],
            action: this.openArModal,
            active: this.state.showArModal,
            activeIcon: arStyle['activeIcon'] || arWhiteIcon,
            activeLabel: undefined,
            activeLabelColor: arStyle['activeLabelColor'],
            activeBackgroundColor: arStyle['activeBackgroundColor'],
            stopPropagation: false,
            showPulseEffect: false,
            showPulseWhenActive: false,
            visible: showButtons,
            disabled: !showButtons
        };
        const rulerButton = {
            id: 'ruler-button',
            icon: rulerStyle['inactiveIcon'] || rulerBlueIcon,
            label: 'Medidas',
            labelColor: rulerStyle['labelColor'],
            backgroundColor: rulerStyle['backgroundColor'],
            action: this.toggleSize,
            active: this.state.showSize,
            activeIcon: rulerStyle['activeIcon'] || rulerWhiteIcon,
            activeLabel: undefined,
            activeLabelColor: rulerStyle['activeLabelColor'],
            activeBackgroundColor: rulerStyle['activeBackgroundColor'],
            stopPropagation: false,
            showPulseEffect: false,
            showPulseWhenActive: false,
            visible: showButtons,
            disabled: !showButtons
        };
        const resetButton = {
            id: 'reset-button',
            icon: resetStyle['inactiveIcon'] || resetBlueIcon,
            label: 'Posición Inicial',
            labelColor: resetStyle['labelColor'],
            backgroundColor: resetStyle['backgroundColor'],
            action: this.resetCameraPosition,
            active: false,
            activeIcon: resetStyle['activeIcon'] || resetWhiteIcon,
            activeLabel: undefined,
            activeLabelColor: resetStyle['activeLabelColor'],
            activeBackgroundColor: resetStyle['activeBackgroundColor'],
            stopPropagation: false,
            showPulseEffect: false,
            showPulseWhenActive: false,
            visible: true,
            disabled: false
        };
        const shareButton = {
            id: 'share-button',
            icon: shareStyle['inactiveIcon'] || shareBlueIcon,
            label: 'Compartir',
            labelColor: shareStyle['labelColor'],
            backgroundColor: shareStyle['backgroundColor'],
            action: this.openShareModal,
            active: this.state.showShareModal,
            activeIcon: shareStyle['activeIcon'] || shareWhiteIcon,
            activeLabel: undefined,
            activeLabelColor: shareStyle['activeLabelColor'],
            activeBackgroundColor: shareStyle['activeBackgroundColor'],
            stopPropagation: false,
            showPulseEffect: false,
            showPulseWhenActive: false,
            visible: showButtons,
            disabled: !showButtons
        };
        const detailsButton = {
            id: 'details-button',
            icon: detailsStyle['inactiveIcon'] || detailsBlueIcon,
            label: 'F. Técnica',
            labelColor: detailsStyle['labelColor'],
            backgroundColor: detailsStyle['backgroundColor'],
            action: this.openProductDetails,
            active: this.state.showProductDetails,
            activeIcon: detailsStyle['activeIcon'] || detailsWhiteIcon,
            activeLabel: undefined,
            activeLabelColor: detailsStyle['activeLabelColor'],
            activeBackgroundColor: detailsStyle['activeBackgroundColor'],
            stopPropagation: false,
            showPulseEffect: false,
            showPulseWhenActive: false,
            visible: showButtons,
            disabled: !showButtons
        };
        const variantsButton = {
            id: 'variants-button',
            icon: variantsStyle['inactiveIcon'] || squaresBlueIcon,
            label: variantsStyle['label'] || 'Variantes',
            labelColor: variantsStyle['labelColor'],
            backgroundColor: variantsStyle['backgroundColor'],
            action: this.toggleVariants,
            active: this.state.showVariants,
            activeIcon: variantsStyle['activeIcon'] || squaresWhiteIcon,
            activeLabel: undefined,
            activeLabelColor: variantsStyle['activeLabelColor'],
            activeBackgroundColor: variantsStyle['activeBackgroundColor'],
            stopPropagation: false,
            showPulseEffect: false,
            showPulseWhenActive: false,
            visible: showButtons,
            disabled: !showButtons
        };
        let actionButton;
        if (product.externalSale) {
            actionButton = {
                id: 'external-sale-button',
                icon: cartStyle['inactiveIcon'] || cartBlueIcon,
                label: 'Comprar online',
                labelColor: cartStyle['labelColor'],
                backgroundColor: cartStyle['backgroundColor'],
                action: () => this.openExternalProductModal('icon-buttons-bar'),
                active: false,
                activeIcon: cartStyle['activeIcon'] || cartWhiteIcon,
                activeLabel: undefined,
                activeLabelColor: cartStyle['activeLabelColor'],
                activeBackgroundColor: cartStyle['activeBackgroundColor'],
                stopPropagation: false,
                showPulseEffect: !hideDetails,
                showPulseWhenActive: false,
                visible: showButtons,
                disabled: !showButtons || !product.isValid()
            };
        } else {
            actionButton = {
                id: 'add-to-cart-button',
                icon: cartStyle['inactiveIcon'] || cartBlueIcon,
                label: 'Agregar al carro',
                labelColor: cartStyle['labelColor'],
                backgroundColor: cartStyle['backgroundColor'],
                action: () => this.addItemToCart('icon-buttons-bar'),
                active: false,
                activeIcon: cartStyle['activeIcon'] || cartWhiteIcon,
                activeLabel: undefined,
                activeLabelColor: cartStyle['activeLabelColor'],
                activeBackgroundColor: cartStyle['activeBackgroundColor'],
                stopPropagation: false,
                showPulseEffect: !hideDetails,
                showPulseWhenActive: false,
                visible: showButtons,
                disabled: !showButtons || !product.isValid()
            };
        }
        if (showActionButton)   buttons.push(actionButton);
        if (showArButton)       buttons.push(arButton);
        if (hideDetailsButton)  buttons.push(detailsButton);
        if (showRulerButton)    buttons.push(rulerButton);
        if (showResetButton)    buttons.push(resetButton);
        if (showDisplayButton)  buttons.push(displayButton);
        if (showShareButton)    buttons.push(shareButton);
        if (showVariantsButton) buttons.push(variantsButton);
        return buttons;
    };

    buildModelViewerUrl = () => {
        const {product, showSize} = this.state;
        let url = product.viewItSceneUrl;
        if (url) {
            url += '&showDimensions=false';
            url += '&showAr=false';
            url += '&showProductLink=false';
            url += '&showTryOnLink=false';
            url += '&showShare=false';
            url += `&drawDimensions=${showSize}`;
            url += `&forceCameraFov=${encodeURIComponent(PLP_3D_DEFAULT_CONFIG.fov)}`;
            url += `&forceCameraDistance=${encodeURIComponent(PLP_3D_DEFAULT_CONFIG.radius)}`;
            return url;
        } else return undefined;
    };

    changeListMode = (mode, showPulseEffect) => {
        const {product} = this.state;
        const metadata = this.props.getMetadata();
        Activity.log(metadata, 'subelements-list', `${mode}-button`, 'click', true, {product_id: product.id, product_name: product.name, mode: mode});
        this.changeState({listMode: mode, listModePulseEffect: showPulseEffect}, () => {
            if (showPulseEffect) {
                setTimeout(() => {
                    this.changeState({listModePulseEffect: false});
                }, 7000);
            }
        });
    };

    changeImage = (id) => {
        const {product} = this.state;
        const metadata = this.props.getMetadata();
        Activity.log(metadata, 'image-gallery', `button-${id}`, 'click', true, {product_id: product.id, product_name: product.name, selected_id: id});
        this.changeState({selectedImageIndex: id});
    };

    getImageSource = () => {
        const {product, selectedVariant} = this.state;
        const variant = selectedVariant ? this.getVariant(selectedVariant) : undefined;
        const variantHasImages = variant && variant.multimedia && variant.multimedia.gallery && variant.multimedia.gallery.length > 0;
        return variantHasImages ? variant : product;
    };

    toSimilarProduct = (category, product) => {
        const metadata = this.props.getMetadata();
        const metricData = {
            from: 'similar-list',
            source_product: {
                product_id: this.state.product.id,
                product_name: this.state.product.name,
                has_3d_model: this.state.product.has3dModel || false
            },
            similar_product: {
                product_id: product.id,
                product_name: product.name,
                has_3d_model: product.has3dModel || false
            },
        };
        if (category) {
            metricData.category = {
                id: category.id || null,
                name: category.name || null
            };
        }
        Activity.log(metadata, 'similar-product', product.id, 'click', true, metricData);
        const url = Navigation.getProductUrl(product.id, undefined, undefined);
        Navigation.forceRedirect(url);
    };

    openActions = () => {
        const metadata = this.props.getMetadata();
        const {product} = this.state;
        this.changeState({showActions: true});
        Activity.log(metadata, 'icon-buttons-bar', 'toggle-button', 'open', true, {product_id: product.id, product_name: product.name});
    };

    closeActions = (closeType) => {
        const metadata = this.props.getMetadata();
        const {product} = this.state;
        this.changeState({showActions: false});
        if (closeType !== 'silent')
            Activity.log(metadata, 'icon-buttons-bar', closeType, 'close', true, {product_id: product.id, product_name: product.name});
    };

    toggleDetails = () => {
        const metadata = this.props.getMetadata();
        const {product} = this.state;
        const newHideDetails = !this.state.hideDetails;
        this.changeState({hideDetails: newHideDetails});
        if (newHideDetails) {
            if (this.props.closeActionBar) this.props.closeActionBar();
            if (this.props.closeActionBarMobile) this.props.closeActionBarMobile('silent');
            if (this._iframeRef && this._iframeRef.current) this._iframeRef.current.contentWindow.postMessage({from: "kiosk", type: 'change-camera-config', data: PLP_3D_FULLSCREEN_CONFIG}, "*");
        } else {
            if (this.props.openActionBar) this.props.openActionBar();
            if (this._iframeRef && this._iframeRef.current) this._iframeRef.current.contentWindow.postMessage({from: "kiosk", type: 'change-camera-config', data: PLP_3D_DEFAULT_CONFIG}, "*");
        }
        Activity.log(metadata, 'icon-buttons-bar', 'toggle-ui-button', newHideDetails ? 'hide' : 'show', true, {product_id: product.id, product_name: product.name});
    };

    openArModal = () => {
        const {product} = this.state;
        const metadata = this.props.getMetadata();
        Activity.log(metadata, 'icon-buttons-bar', 'ar-button', 'open', true, {product_id: product.id, product_name: product.name});
        this.changeState({showArModal: true});
    };

    closeArModal = () => {
        this.changeState({showArModal: false});
    };

    toggleSize = () => {
        const {product} = this.state;
        const metadata = this.props.getMetadata();
        const showSize = !this.state.showSize;
        this.changeState({showSize: showSize});
        if (this._iframeRef && this._iframeRef.current) {
            if (this._iframeRef && this._iframeRef.current) this._iframeRef.current.contentWindow.postMessage({from: "kiosk", type: `${showSize ? 'show' : 'hide'}-dimensions`, data: {}}, "*");
        }
        Activity.log(metadata, 'icon-buttons-bar', 'toggle-size-button', showSize ? 'show' : 'hide', true, {product_id: product.id, product_name: product.name});
    };

    resetCameraPosition = () => {
        const {product, hideDetails} = this.state;
        const metadata = this.props.getMetadata();
        if (this._iframeRef && this._iframeRef.current) {
            if (this._iframeRef && this._iframeRef.current) this._iframeRef.current.contentWindow.postMessage({from: "kiosk", type: 'change-camera-config', data: hideDetails ? PLP_3D_FULLSCREEN_CONFIG : PLP_3D_DEFAULT_CONFIG}, "*");
        }
        Activity.log(metadata, 'icon-buttons-bar', 'reset-camera-position', 'reset', true, {product_id: product.id, product_name: product.name});
    };

    openShareModal = () => {
        const {product} = this.state;
        const metadata = this.props.getMetadata();
        this.changeState({showShareModal: true});
        Activity.log(metadata, 'icon-buttons-bar', 'share-button', 'open', true, {product_id: product.id, product_name: product.name});
    };

    closeShareModal = () => {
        this.changeState({showShareModal: false});
    };

    openProductDetails = () => {
        const {product} = this.state;
        const metadata = this.props.getMetadata();
        Activity.log(metadata, 'icon-buttons-bar', 'details-button', 'open', true, {product_id: product.id, product_name: product.name});
        this.changeState({showProductDetails: true});
    };

    closeProductDetails = () => {
        this.changeState({showProductDetails: false});
    };

    openVariants = () => {
        const {product} = this.state;
        const metadata = this.props.getMetadata();
        Activity.log(metadata, 'icon-buttons-bar', 'variants-button', 'open', true, {product_id: product.id, product_name: product.name});
        this.changeState({showVariants: true});
    };

    closeVariants = () => {
        this.changeState({showVariants: false});
    };

    toggleVariants = () => {
        const {showVariants} = this.state;
        if (showVariants) this.closeVariants();
        else this.openVariants();
    };

    selectVariant = (id) => {
        this.changeState({selectedVariant: id, selectedImageIndex: '0'});
    };

    getVariant = (id) => {
        return this.state.product && this.state.product.variants && this.state.product.variants.length > 0 ? this.state.product.variants.find((variant) => variant.id === id) : undefined;
    };

    addItemToCart = (entityType) => {
        const {queryId, product, selectedVariant} = this.state;
        const variant = selectedVariant ? this.getVariant(selectedVariant) : undefined;
        const source = variant ? variant : product;
        if (source.onRequest) {
            this.openOnRequestProductModal();
            return;
        }
        const type = variant ? 'variant' : 'product';
        const id = `${this.props.client}-${source.id}`;
        const item = new _ShoppingCartItem({
            id: id,
            product: source.id,
            type: type,
            parent: type === 'variant' ? product.id : undefined,
            name: source.name,
            quantity: 1,
            minQuantity: 1,
            maxQuantity: source.maxPerItem,
            normalPrice: source.normalPrice,
            offerPrice: source.offerPrice,
            exclusivePrice: source.exclusivePrice,
            queryId: queryId
        });
        if (this.props.addItemToCart) {
            this.props.addItemToCart(item)
                .then(() => {
                    const metadata = this.props.getMetadata();
                    Activity.log(metadata, entityType, 'add-to-cart-button', 'add', true, item.toActivityLog(1));
                    if (this.props.openShoppingCart) this.props.openShoppingCart();
                });
        }
    };

    openExternalProductModal = (entityType) => {
        const {product, selectedVariant} = this.state;
        const variant = selectedVariant ? this.getVariant(selectedVariant) : undefined;
        const categoryPath = product.categoryPaths && product.categoryPaths.length > 0 ? product.categoryPaths[0] : null;
        const metadata = this.props.getMetadata();
        Activity.log(metadata, entityType, 'buy-online-button', 'external-sale', true, {product_id: product.id, product_name: product.name, variant_id: variant ? variant.id : null, variant_name: variant ? variant.name : null, category_path: categoryPath});
        this.changeState({showExternalProductModal: true});
    };

    closeExternalProductModal = () => {
        this.changeState({showExternalProductModal: false});
    };

    openOnRequestProductModal = () => {
        const {product, selectedVariant} = this.state;
        const variant = selectedVariant ? this.getVariant(selectedVariant) : undefined;
        const metadata = this.props.getMetadata();
        Activity.log(metadata, 'icon-buttons-bar', 'add-to-cart-button', 'on-request-product-alert', true, {product_id: product.id, product_name: product.name, variant_id: variant ? variant.id : null, variant_name: variant ? variant.name : null});
        this.changeState({showOnRequestProductModal: true});
    };

    closeOnRequestProductModal = () => {
        this.changeState({showOnRequestProductModal: false});
    };

    openNoStockModal = () => {
        this.changeState({showNoStockModal: true});
    };

    closeNoStockModal = () => {
        this.changeState({showNoStockModal: false});
    };

    contentStyle = () => {
        const viewport = Viewport.dimensions;
        const {showProductDetails, showVariants} = this.state;
        return {
            width: showProductDetails || showVariants ? 'calc(100% - 320px)' : '100%',
            height: viewport.height
        };
    };

    listStyle = () => {
        const {hideDetails} = this.state;
        return {
            pointerEvents: hideDetails ? 'none' : 'auto'
        };
    };

    viewerStyle = () => {
        const viewport = Viewport.dimensions;
        const {showProductDetails, showVariants} = this.state;
        return {
            width: viewport.width >= 1250 && (showProductDetails || showVariants) ? 'calc(100% - 320px)' : '100%',
            height: '100%'
        };
    };

    renderTitle = () => {
        const {product, selectedVariant} = this.state;
        const {style} = this.props;
        const source = selectedVariant ? this.getVariant(selectedVariant) : product;
        const clientName = style && style['global'] && style['global']['clientName'] ? style['global']['clientName'] : undefined;
        const taxMultiplier = style && style['global'] && style['global']['checkout'] && style['global']['checkout']['taxMultiplier'] ? style['global']['checkout']['taxMultiplier'] : 1;
        const taxLabel = style && style['global'] && style['global']['checkout'] && style['global']['checkout']['taxLabel'] ? style['global']['checkout']['taxLabel'] : 'DESC';
        const discountBackgroundColor = style && style['global'] && style['global']['prices'] && style['global']['prices']['discountBackgroundColor'] ? style['global']['prices']['discountBackgroundColor'] : undefined;
        const discountLabelColor = style && style['global'] && style['global']['prices'] && style['global']['prices']['discountLabelColor'] ? style['global']['prices']['discountLabelColor'] : undefined;
        const exclusivePriceLabelColor = style && style['global'] && style['global']['prices'] && style['global']['prices']['exclusivePriceLabelColor'] ? style['global']['prices']['exclusivePriceLabelColor'] : undefined;
        const exclusivePriceIcon = style && style['global'] && style['global']['prices'] && style['global']['prices']['exclusivePriceIcon'] ? style['global']['prices']['exclusivePriceIcon'] : undefined;
        const freeDeliveryIcon = style && style['global'] && style['global']['tags'] && style['global']['tags']['freeDelivery'] && style['global']['tags']['freeDelivery']['icon'] ? style['global']['tags']['freeDelivery']['icon'] : undefined;
        const freeDeliveryLabelColor = style && style['global'] && style['global']['tags'] && style['global']['tags']['freeDelivery'] && style['global']['tags']['freeDelivery']['labelColor'] ? style['global']['tags']['freeDelivery']['labelColor'] : undefined;
        const freeDeliveryBackgroundColor = style && style['global'] && style['global']['tags'] && style['global']['tags']['freeDelivery'] && style['global']['tags']['freeDelivery']['backgroundColor'] ? style['global']['tags']['freeDelivery']['backgroundColor'] : undefined;
        const deliveryIcon = style && style['global'] && style['global']['tags'] && style['global']['tags']['delivery'] && style['global']['tags']['delivery']['icon'] ? style['global']['tags']['delivery']['icon'] : undefined;
        const deliveryLabelColor = style && style['global'] && style['global']['tags'] && style['global']['tags']['delivery'] && style['global']['tags']['delivery']['labelColor'] ? style['global']['tags']['delivery']['labelColor'] : undefined;
        const deliveryBackgroundColor = style && style['global'] && style['global']['tags'] && style['global']['tags']['delivery'] && style['global']['tags']['delivery']['backgroundColor'] ? style['global']['tags']['delivery']['backgroundColor'] : undefined;
        const pickupIcon = style && style['global'] && style['global']['tags'] && style['global']['tags']['pickup'] && style['global']['tags']['pickup']['icon'] ? style['global']['tags']['pickup']['icon'] : undefined;
        const pickupLabelColor = style && style['global'] && style['global']['tags'] && style['global']['tags']['pickup'] && style['global']['tags']['pickup']['labelColor'] ? style['global']['tags']['pickup']['labelColor'] : undefined;
        const pickupBackgroundColor = style && style['global'] && style['global']['tags'] && style['global']['tags']['pickup'] && style['global']['tags']['pickup']['backgroundColor'] ? style['global']['tags']['pickup']['backgroundColor'] : undefined;
        const infoTagBorderColor = style && style['global'] && style['global']['tags'] && style['global']['tags']['infoTag'] && style['global']['tags']['infoTag']['borderColor'] ? style['global']['tags']['infoTag']['borderColor'] : undefined;
        const infoTagBackgroundColor = style && style['global'] && style['global']['tags'] && style['global']['tags']['infoTag'] && style['global']['tags']['infoTag']['backgroundColor'] ? style['global']['tags']['infoTag']['backgroundColor'] : undefined;
        const infoTagLabelColor = style && style['global'] && style['global']['tags'] && style['global']['tags']['infoTag'] && style['global']['tags']['infoTag']['labelColor'] ? style['global']['tags']['infoTag']['labelColor'] : undefined;
        const sellerLabelColor = style && style['global'] && style['global']['seller'] && style['global']['seller']['labelColor'] ? style['global']['seller']['labelColor'] : undefined;
        const mainSellerIcon = style && style['global'] && style['global']['seller'] && style['global']['seller']['mainIcon'] ? style['global']['seller']['mainIcon'] : undefined;
        const taxDisclaimerBackgroundColor = style && style['category'] && style['category']['taxDisclaimerBackgroundColor'] ? style['category']['taxDisclaimerBackgroundColor'] : undefined;
        const taxDisclaimerLabelColor = style && style['category'] && style['category']['taxDisclaimerLabelColor'] ? style['category']['taxDisclaimerLabelColor'] : undefined;
        const showInfoTagOnImage = style && style['category'] ? style['category']['showInfoTagOnImage'] : false;
        const infoTagLabel = style && style['category'] ? style['category']['infoTagLabel'] : undefined;
        const infoTagProperty = style && style['category'] ? style['category']['infoTagProperty'] : undefined;
        return (
            <div className={`product-view-product-title ${this.state.hideDetails ? 'hidden' : 'visible'}`}>
                <ProductTitle
                    product={source}
                    isSidebarOpen={this.state.showProductDetails || this.state.showVariants}
                    clientName={clientName}
                    taxMultiplier={taxMultiplier}
                    taxLabel={taxLabel}
                    discountBackgroundColor={discountBackgroundColor}
                    discountLabelColor={discountLabelColor}
                    exclusivePriceLabelColor={exclusivePriceLabelColor}
                    exclusivePriceIcon={exclusivePriceIcon}
                    freeDeliveryIcon={freeDeliveryIcon}
                    freeDeliveryLabelColor={freeDeliveryLabelColor}
                    freeDeliveryBackgroundColor={freeDeliveryBackgroundColor}
                    deliveryIcon={deliveryIcon}
                    deliveryLabelColor={deliveryLabelColor}
                    deliveryBackgroundColor={deliveryBackgroundColor}
                    pickupIcon={pickupIcon}
                    pickupLabelColor={pickupLabelColor}
                    pickupBackgroundColor={pickupBackgroundColor}
                    infoTagBorderColor={infoTagBorderColor}
                    infoTagBackgroundColor={infoTagBackgroundColor}
                    infoTagLabelColor={infoTagLabelColor}
                    sellerLabelColor={sellerLabelColor}
                    mainSellerIcon={mainSellerIcon}
                    taxDisclaimerBackgroundColor={taxDisclaimerBackgroundColor}
                    taxDisclaimerLabelColor={taxDisclaimerLabelColor}
                    showInfoTagOnImage={showInfoTagOnImage}
                    infoTagLabel={infoTagLabel}
                    infoTagProperty={infoTagProperty}
                />
            </div>
        );
    };

    renderList = (showScrollbar, type) => {
        const {listMode, hideDetails} = this.state;
        const similar = this.getFilteredSimilar();
        return (
            <div className='product-view-product-list'>
                {similar.length > 0 && (
                    <div className='product-view-product-tabs'>
                        <div className={`product-view-images-mode-tab ${listMode === 'images' ? 'selected' : ''} ${hideDetails ? 'hidden' : 'visible'}`} onClick={() => this.changeListMode('images', false)}>Imágenes</div>
                        <div className={`product-view-images-mode-tab ${listMode === 'similar' ? 'selected' : ''} ${hideDetails ? 'hidden' : 'visible'}`} onClick={() => this.changeListMode('similar', false)}>Similares</div>
                    </div>
                )}
                {listMode === 'images' && this.renderImagesList(showScrollbar, type)}
                {listMode === 'similar' && this.renderSimilarProducts(similar, showScrollbar, type)}
            </div>
        );
    };

    renderImagesList = (showScrollbar, type) => {
        const {selectedImageIndex, hideDetails} = this.state;
        return (
            <ImageList
                key={`product-image-list-${type}`}
                product={this.getImageSource()}
                initialSelectedId={selectedImageIndex}
                has3dModel={!!this.state.product.viewItSceneUrl}
                showScrollbar={showScrollbar}
                visible={!hideDetails}
                disabled={hideDetails}
                onClick={this.changeImage}
            />
        );
    };

    renderSimilarProducts = (similar, showScrollbar, type) => {
        const {hideDetails, listModePulseEffect} = this.state;
        const {style} = this.props;
        const clientName = style && style['global'] && style['global']['clientName'] ? style['global']['clientName'] : undefined;
        const taxMultiplier = style && style['global'] && style['global']['checkout'] && style['global']['checkout']['taxMultiplier'] ? style['global']['checkout']['taxMultiplier'] : 1;
        const taxLabel = style && style['global'] && style['global']['checkout'] && style['global']['checkout']['taxLabel'] ? style['global']['checkout']['taxLabel'] : 'DESC';
        const productBoxDesign = style && style['category'] && style['category']['productBoxDesign'] ? style['category']['productBoxDesign'] : undefined;
        const actionButtonBorderColor = style && style['global'] && style['global']['actionButton'] && style['global']['actionButton']['borderColor'] ? style['global']['actionButton']['borderColor'] : undefined;
        const discountBackgroundColor = style && style['global'] && style['global']['prices'] && style['global']['prices']['discountBackgroundColor'] ? style['global']['prices']['discountBackgroundColor'] : undefined;
        const discountLabelColor = style && style['global'] && style['global']['prices'] && style['global']['prices']['discountLabelColor'] ? style['global']['prices']['discountLabelColor'] : undefined;
        const exclusivePriceLabelColor = style && style['global'] && style['global']['prices'] && style['global']['prices']['exclusivePriceLabelColor'] ? style['global']['prices']['exclusivePriceLabelColor'] : undefined;
        const exclusivePriceIcon = style && style['global'] && style['global']['prices'] && style['global']['prices']['exclusivePriceIcon'] ? style['global']['prices']['exclusivePriceIcon'] : undefined;
        const offerBackgroundColor = style && style['global'] && style['global']['offers'] && style['global']['offers']['backgroundColor'] ? style['global']['offers']['backgroundColor'] : undefined;
        const offerLabelColor = style && style['global'] && style['global']['offers'] && style['global']['offers']['labelColor'] ? style['global']['offers']['labelColor'] : undefined;
        const offerLabel = style && style['global'] && style['global']['offers'] && style['global']['offers']['label'] ? style['global']['offers']['label'] : undefined;
        const offerIcon = style && style['global'] && style['global']['offers'] && style['global']['offers']['icon'] ? style['global']['offers']['icon'] : undefined;
        const infoTagBorderColor = style && style['global'] && style['global']['tags'] && style['global']['tags']['infoTag'] && style['global']['tags']['infoTag']['borderColor'] ? style['global']['tags']['infoTag']['borderColor'] : undefined;
        const infoTagBackgroundColor = style && style['global'] && style['global']['tags'] && style['global']['tags']['infoTag'] && style['global']['tags']['infoTag']['backgroundColor'] ? style['global']['tags']['infoTag']['backgroundColor'] : undefined;
        const infoTagLabelColor = style && style['global'] && style['global']['tags'] && style['global']['tags']['infoTag'] && style['global']['tags']['infoTag']['labelColor'] ? style['global']['tags']['infoTag']['labelColor'] : undefined;
        const sellerLabelColor = style && style['global'] && style['global']['seller'] && style['global']['seller']['labelColor'] ? style['global']['seller']['labelColor'] : undefined;
        const mainSellerIcon = style && style['global'] && style['global']['seller'] && style['global']['seller']['mainIcon'] ? style['global']['seller']['mainIcon'] : undefined;
        const taxDisclaimerBackgroundColor = style && style['category'] && style['category']['taxDisclaimerBackgroundColor'] ? style['category']['taxDisclaimerBackgroundColor'] : undefined;
        const taxDisclaimerLabelColor = style && style['category'] && style['category']['taxDisclaimerLabelColor'] ? style['category']['taxDisclaimerLabelColor'] : undefined;
        const showRating = style && style['category'] ? style['category']['showRating'] : false;
        const showInfoTagOnImage = style && style['category'] ? style['category']['showInfoTagOnImage'] : false;
        const infoTagLabel = style && style['category'] ? style['category']['infoTagLabel'] : undefined;
        const infoTagProperty = style && style['category'] ? style['category']['infoTagProperty'] : undefined;
        return (
            <ProductBoxSlider
                key={`similar-products-list-${type}`}
                category={undefined}
                products={similar}
                showScrollbar={showScrollbar}
                visible={!hideDetails}
                disabled={hideDetails}
                clientName={clientName}
                taxMultiplier={taxMultiplier}
                taxLabel={taxLabel}
                productBoxDesign={productBoxDesign}
                discountBackgroundColor={discountBackgroundColor}
                discountLabelColor={discountLabelColor}
                exclusivePriceLabelColor={exclusivePriceLabelColor}
                exclusivePriceIcon={exclusivePriceIcon}
                offerBackgroundColor={offerBackgroundColor}
                offerLabelColor={offerLabelColor}
                offerLabel={offerLabel}
                offerIcon={offerIcon}
                infoTagBorderColor={infoTagBorderColor}
                infoTagBackgroundColor={infoTagBackgroundColor}
                infoTagLabelColor={infoTagLabelColor}
                sellerLabelColor={sellerLabelColor}
                mainSellerIcon={mainSellerIcon}
                taxDisclaimerBackgroundColor={taxDisclaimerBackgroundColor}
                taxDisclaimerLabelColor={taxDisclaimerLabelColor}
                showPulseEffect={listModePulseEffect}
                pulseEffectColor={actionButtonBorderColor}
                showSeller={false}
                showDelivery={false}
                showRating={showRating}
                showTags={false}
                showInfoTagOnImage={showInfoTagOnImage}
                infoTagLabel={infoTagLabel}
                infoTagProperty={infoTagProperty}
                onClick={this.toSimilarProduct}
            />
        );
    };

    renderIconButtonsGrid = () => {
        if (this.props.inSmallMode) {
            const {style} = this.props;
            const mobileBarBackground = style && style['product'] && style['product']['actionButtons'] && style['product']['actionButtons']['mobileBarBackground'] ? style['product']['actionButtons']['mobileBarBackground'] : undefined;
            return (
                <React.Fragment>
                    {this.props.inSmallMode && (
                        <div className='product-view-icon-buttons-grid-toggle' onClick={this.state.showActions ? () => this.closeActions('toggle-button') : this.openActions}>
                            <img className='product-view-icon-buttons-grid-toggle-icon' src={`${caretIcon}`} alt='toggle' draggable={false}/>
                        </div>
                    )}
                    {this.state.showActions && (
                        <Modal
                            mode='right'
                            smallMode={false}
                            backgroundColor={mobileBarBackground}
                            borderRadius={0}
                            padding='0'
                            width={130}
                            minWidth={130}
                            maxWidth={130}
                            height='100%'
                            minHeight='100%'
                            maxHeight='100%'
                            showDefaultCloseButton={true}
                            customDefaultCloseButtonPosition={{top: 10, right: 10}}
                            onClose={this.closeActions}
                        >
                            <div className='product-view-icon-buttons-grid mobile'>
                                <IconButtonsGrid
                                    id='product-view-icon-buttons-grid'
                                    mode='vertical'
                                    buttons={this.getIconButtons()}
                                    defaultAction={() => this.closeActions('silent')}
                                />
                            </div>
                        </Modal>
                    )}
                </React.Fragment>
            );
        } else {
            return (
                <div className='product-view-icon-buttons-grid normal'>
                    <IconButtonsGrid
                        id='product-view-icon-buttons-grid'
                        mode='vertical'
                        buttons={this.getIconButtons()}
                        defaultAction={undefined}
                    />
                </div>
            );
        }
    };

    renderArModal = () => {
        const {style} = this.props;
        const qrScanImage = style && style['product'] && style['product']['arModalQrScanImage'] ? style['product']['arModalQrScanImage'] : undefined;
        const cancelButtonBackgroundColor = style && style['global'] && style['global']['cancelButton'] && style['global']['cancelButton']['backgroundColor'] ? style['global']['cancelButton']['backgroundColor'] : undefined;
        const cancelButtonBorderColor = style && style['global'] && style['global']['cancelButton'] && style['global']['cancelButton']['borderColor'] ? style['global']['cancelButton']['borderColor'] : undefined;
        const cancelButtonLabelColor = style && style['global'] && style['global']['cancelButton'] && style['global']['cancelButton']['labelColor'] ? style['global']['cancelButton']['labelColor'] : undefined;
        return (
            <ARModal
                product={this.state.product}
                arUrl={this.state.product.viewItArUrl}
                qrScanImage={qrScanImage}
                cancelButtonBackgroundColor={cancelButtonBackgroundColor}
                cancelButtonBorderColor={cancelButtonBorderColor}
                cancelButtonLabelColor={cancelButtonLabelColor}
                onClose={this.closeArModal}
                metadata={this.props.getMetadata()}
            />
        );
    };

    renderProductDetailsSidebar = () => {
        const {product, showProductDetails} = this.state;
        const {style} = this.props;
        const tabHoverLabelColor = style && style['global'] && style['global']['sidebarTabs'] && style['global']['sidebarTabs']['hoverLabelColor'] ? style['global']['sidebarTabs']['hoverLabelColor'] : undefined;
        const tabHoverBorderColor = style && style['global'] && style['global']['sidebarTabs'] && style['global']['sidebarTabs']['hoverBorderColor'] ? style['global']['sidebarTabs']['hoverBorderColor'] : undefined;
        const cancelButtonBackgroundColor = style && style['global'] && style['global']['cancelButton'] && style['global']['cancelButton']['backgroundColor'] ? style['global']['cancelButton']['backgroundColor'] : undefined;
        const cancelButtonBorderColor = style && style['global'] && style['global']['cancelButton'] && style['global']['cancelButton']['borderColor'] ? style['global']['cancelButton']['borderColor'] : undefined;
        const cancelButtonLabelColor = style && style['global'] && style['global']['cancelButton'] && style['global']['cancelButton']['labelColor'] ? style['global']['cancelButton']['labelColor'] : undefined;
        const showAIGeneratedFeatures = style && style['global'] && style['global']['features'] && style['global']['features']['showAIGeneratedFeatures'] ? style['global']['features']['showAIGeneratedFeatures'] : false;
        const showAIGeneratedTag = style && style['global'] && style['global']['features'] && style['global']['features']['showAIGeneratedTag'] ? style['global']['features']['showAIGeneratedTag'] : false;
        const AIGeneratedTagLabel = style && style['global'] && style['global']['features'] && style['global']['features']['AIGeneratedTagLabel'] ? style['global']['features']['AIGeneratedTagLabel'] : undefined;
        const AIGeneratedTagBackgroundColor = style && style['global'] && style['global']['features'] && style['global']['features']['AIGeneratedTagBackgroundColor'] ? style['global']['features']['AIGeneratedTagBackgroundColor'] : undefined;
        const AIGeneratedTagLabelColor = style && style['global'] && style['global']['features'] && style['global']['features']['AIGeneratedTagLabelColor'] ? style['global']['features']['AIGeneratedTagLabelColor'] : undefined;
        const AIGeneratedTagBorderColor = style && style['global'] && style['global']['features'] && style['global']['features']['AIGeneratedTagBorderColor'] ? style['global']['features']['AIGeneratedTagBorderColor'] : undefined;
        return (
            <ProductDetailsSidebar
                isOpen={showProductDetails}
                product={product}
                tabHoverLabelColor={tabHoverLabelColor}
                tabHoverBorderColor={tabHoverBorderColor}
                cancelButtonBackgroundColor={cancelButtonBackgroundColor}
                cancelButtonBorderColor={cancelButtonBorderColor}
                cancelButtonLabelColor={cancelButtonLabelColor}
                showAIGeneratedFeatures={showAIGeneratedFeatures}
                showAIGeneratedTag={showAIGeneratedTag}
                AIGeneratedTagLabel={AIGeneratedTagLabel}
                AIGeneratedTagBackgroundColor={AIGeneratedTagBackgroundColor}
                AIGeneratedTagLabelColor={AIGeneratedTagLabelColor}
                AIGeneratedTagBorderColor={AIGeneratedTagBorderColor}
                onClose={this.closeProductDetails}
                metadata={this.props.getMetadata()}
            />
        );
    };

    renderProductVariantsSidebar = () => {
        const {product, selectedVariant, showVariants} = this.state;
        const {style} = this.props;
        const tabHoverLabelColor = style && style['global'] && style['global']['sidebarTabs'] && style['global']['sidebarTabs']['hoverLabelColor'] ? style['global']['sidebarTabs']['hoverLabelColor'] : undefined;
        const tabHoverBorderColor = style && style['global'] && style['global']['sidebarTabs'] && style['global']['sidebarTabs']['hoverBorderColor'] ? style['global']['sidebarTabs']['hoverBorderColor'] : undefined;
        const discountBackgroundColor = style && style['global'] && style['global']['prices'] && style['global']['prices']['discountBackgroundColor'] ? style['global']['prices']['discountBackgroundColor'] : undefined;
        const discountLabelColor = style && style['global'] && style['global']['prices'] && style['global']['prices']['discountLabelColor'] ? style['global']['prices']['discountLabelColor'] : undefined;
        const exclusivePriceLabelColor = style && style['global'] && style['global']['prices'] && style['global']['prices']['exclusivePriceLabelColor'] ? style['global']['prices']['exclusivePriceLabelColor'] : undefined;
        const exclusivePriceIcon = style && style['global'] && style['global']['prices'] && style['global']['prices']['exclusivePriceIcon'] ? style['global']['prices']['exclusivePriceIcon'] : undefined;
        const selectedVariantBorderColor = style && style['global'] && style['global']['actionButton'] && style['global']['actionButton']['backgroundColor'] ? style['global']['actionButton']['backgroundColor'] : undefined;
        const addToCartButtonIcon = style && style['product'] && style['product']['variantsSidebarAddToCartButtonIcon'] ? style['product']['variantsSidebarAddToCartButtonIcon'] : undefined;
        const actionButtonBackgroundColor = style && style['global'] && style['global']['actionButton'] && style['global']['actionButton']['backgroundColor'] ? style['global']['actionButton']['backgroundColor'] : undefined;
        const actionButtonBorderColor = style && style['global'] && style['global']['actionButton'] && style['global']['actionButton']['borderColor'] ? style['global']['actionButton']['borderColor'] : undefined;
        const actionButtonLabelColor = style && style['global'] && style['global']['actionButton'] && style['global']['actionButton']['labelColor'] ? style['global']['actionButton']['labelColor'] : undefined;
        const cancelButtonBackgroundColor = style && style['global'] && style['global']['cancelButton'] && style['global']['cancelButton']['backgroundColor'] ? style['global']['cancelButton']['backgroundColor'] : undefined;
        const cancelButtonBorderColor = style && style['global'] && style['global']['cancelButton'] && style['global']['cancelButton']['borderColor'] ? style['global']['cancelButton']['borderColor'] : undefined;
        const cancelButtonLabelColor = style && style['global'] && style['global']['cancelButton'] && style['global']['cancelButton']['labelColor'] ? style['global']['cancelButton']['labelColor'] : undefined;
        return (
            <ProductVariantsSidebar
                isOpen={showVariants}
                product={product}
                selectedVariant={selectedVariant}
                tabHoverLabelColor={tabHoverLabelColor}
                tabHoverBorderColor={tabHoverBorderColor}
                discountBackgroundColor={discountBackgroundColor}
                discountLabelColor={discountLabelColor}
                exclusivePriceLabelColor={exclusivePriceLabelColor}
                exclusivePriceIcon={exclusivePriceIcon}
                selectedVariantBorderColor={selectedVariantBorderColor}
                addToCartButtonIcon={addToCartButtonIcon}
                actionButtonBackgroundColor={actionButtonBackgroundColor}
                actionButtonBorderColor={actionButtonBorderColor}
                actionButtonLabelColor={actionButtonLabelColor}
                cancelButtonBackgroundColor={cancelButtonBackgroundColor}
                cancelButtonBorderColor={cancelButtonBorderColor}
                cancelButtonLabelColor={cancelButtonLabelColor}
                onVariantClick={this.selectVariant}
                onAddToCartClick={this.addItemToCart}
                onBuyOnlineClick={this.openExternalProductModal}
                onClose={this.closeVariants}
                metadata={this.props.getMetadata()}
            />
        );
    };

    renderShareModal = () => {
        const {style} = this.props;
        const qrScanImage = style && style['product'] && style['product']['arModalQrScanImage'] ? style['product']['arModalQrScanImage'] : undefined;
        const cancelButtonBackgroundColor = style && style['global'] && style['global']['cancelButton'] && style['global']['cancelButton']['backgroundColor'] ? style['global']['cancelButton']['backgroundColor'] : undefined;
        const cancelButtonBorderColor = style && style['global'] && style['global']['cancelButton'] && style['global']['cancelButton']['borderColor'] ? style['global']['cancelButton']['borderColor'] : undefined;
        const cancelButtonLabelColor = style && style['global'] && style['global']['cancelButton'] && style['global']['cancelButton']['labelColor'] ? style['global']['cancelButton']['labelColor'] : undefined;
        return (
            <ShareModal
                product={this.state.product}
                shareUrl={this.state.product.viewItSceneUrl}
                qrScanImage={qrScanImage}
                cancelButtonBackgroundColor={cancelButtonBackgroundColor}
                cancelButtonBorderColor={cancelButtonBorderColor}
                cancelButtonLabelColor={cancelButtonLabelColor}
                onClose={this.closeShareModal}
                metadata={this.props.getMetadata()}
            />
        );
    };

    renderExternalProductModal = () => {
        if (!this.state.product.externalSaleUrl) return undefined;
        const metadata = this.props.getMetadata();
        const {client, store, style} = this.props;
        const {queryId, product, selectedVariant} = this.state;
        const variant = selectedVariant ? this.getVariant(selectedVariant) : undefined;
        const clientName = style && style['global'] && style['global']['clientName'] ? style['global']['clientName'] : undefined;
        const mainSellerIcon = style && style['global'] && style['global']['seller'] && style['global']['seller']['mainIcon'] ? style['global']['seller']['mainIcon'] : undefined;
        const qrScanImage = style && style['product'] && style['product']['externalProductModalQrScanImage'] ? style['product']['externalProductModalQrScanImage'] : undefined;
        const actionButtonBackgroundColor = style && style['global'] && style['global']['actionButton'] && style['global']['actionButton']['backgroundColor'] ? style['global']['actionButton']['backgroundColor'] : undefined;
        const actionButtonBorderColor = style && style['global'] && style['global']['actionButton'] && style['global']['actionButton']['borderColor'] ? style['global']['actionButton']['borderColor'] : undefined;
        const actionButtonLabelColor = style && style['global'] && style['global']['actionButton'] && style['global']['actionButton']['labelColor'] ? style['global']['actionButton']['labelColor'] : undefined;
        const cancelButtonBackgroundColor = style && style['global'] && style['global']['cancelButton'] && style['global']['cancelButton']['backgroundColor'] ? style['global']['cancelButton']['backgroundColor'] : undefined;
        const cancelButtonBorderColor = style && style['global'] && style['global']['cancelButton'] && style['global']['cancelButton']['borderColor'] ? style['global']['cancelButton']['borderColor'] : undefined;
        const cancelButtonLabelColor = style && style['global'] && style['global']['cancelButton'] && style['global']['cancelButton']['labelColor'] ? style['global']['cancelButton']['labelColor'] : undefined;
        return (
            <ExternalProductModal
                queryId={queryId}
                client={client}
                clientName={clientName}
                store={store}
                product={product}
                variant={variant}
                mainSellerIcon={mainSellerIcon}
                qrScanImage={qrScanImage}
                actionButtonBackgroundColor={actionButtonBackgroundColor}
                actionButtonBorderColor={actionButtonBorderColor}
                actionButtonLabelColor={actionButtonLabelColor}
                cancelButtonBackgroundColor={cancelButtonBackgroundColor}
                cancelButtonBorderColor={cancelButtonBorderColor}
                cancelButtonLabelColor={cancelButtonLabelColor}
                onClose={this.closeExternalProductModal}
                metadata={metadata}
            />
        );
    };

    renderOnRequestProductModal = () => {
        const {product, selectedVariant} = this.state;
        const variant = selectedVariant ? this.getVariant(selectedVariant) : undefined;
        const metadata = this.props.getMetadata();
        const {style} = this.props;
        const cancelButtonBackgroundColor = style && style['global'] && style['global']['actionButton'] && style['global']['actionButton']['backgroundColor'] ? style['global']['actionButton']['backgroundColor'] : undefined;
        const cancelButtonBorderColor = style && style['global'] && style['global']['actionButton'] && style['global']['actionButton']['borderColor'] ? style['global']['actionButton']['borderColor'] : undefined;
        const cancelButtonLabelColor = style && style['global'] && style['global']['actionButton'] && style['global']['actionButton']['labelColor'] ? style['global']['actionButton']['labelColor'] : undefined;
        return (
            <OnRequestProductModal
                product={product}
                variant={variant}
                cancelButtonBackgroundColor={cancelButtonBackgroundColor}
                cancelButtonBorderColor={cancelButtonBorderColor}
                cancelButtonLabelColor={cancelButtonLabelColor}
                onClose={this.closeOnRequestProductModal}
                metadata={metadata}
            />
        );
    };

    renderNoStockModal = () => {
        const {product, selectedVariant} = this.state;
        const variant = selectedVariant ? this.getVariant(selectedVariant) : undefined;
        const metadata = this.props.getMetadata();
        const {style} = this.props;
        const actionButtonBackgroundColor = style && style['global'] && style['global']['actionButton'] && style['global']['actionButton']['backgroundColor'] ? style['global']['actionButton']['backgroundColor'] : undefined;
        const actionButtonBorderColor = style && style['global'] && style['global']['actionButton'] && style['global']['actionButton']['borderColor'] ? style['global']['actionButton']['borderColor'] : undefined;
        const actionButtonLabelColor = style && style['global'] && style['global']['actionButton'] && style['global']['actionButton']['labelColor'] ? style['global']['actionButton']['labelColor'] : undefined;
        const cancelButtonBackgroundColor = style && style['global'] && style['global']['cancelButton'] && style['global']['cancelButton']['backgroundColor'] ? style['global']['cancelButton']['backgroundColor'] : undefined;
        const cancelButtonBorderColor = style && style['global'] && style['global']['cancelButton'] && style['global']['cancelButton']['borderColor'] ? style['global']['cancelButton']['borderColor'] : undefined;
        const cancelButtonLabelColor = style && style['global'] && style['global']['cancelButton'] && style['global']['cancelButton']['labelColor'] ? style['global']['cancelButton']['labelColor'] : undefined;
        return (
            <NoStockModal
                product={product}
                variant={variant}
                similar={this.getFilteredSimilar()}
                actionButtonBackgroundColor={actionButtonBackgroundColor}
                actionButtonBorderColor={actionButtonBorderColor}
                actionButtonLabelColor={actionButtonLabelColor}
                cancelButtonBackgroundColor={cancelButtonBackgroundColor}
                cancelButtonBorderColor={cancelButtonBorderColor}
                cancelButtonLabelColor={cancelButtonLabelColor}
                onClose={this.closeNoStockModal}
                openSimilarProducts={() => this.changeListMode('similar', true)}
                metadata={metadata}
            />
        );
    };

    render() {
        let {style} = this.props;
        const viewport = Viewport.dimensions;
        const showTopGallery = viewport.height >= 1600;
        const actionButtonBackgroundColor = style && style['global'] && style['global']['actionButton'] && style['global']['actionButton']['backgroundColor'] ? style['global']['actionButton']['backgroundColor'] : undefined;
        const actionButtonBorderColor = style && style['global'] && style['global']['actionButton'] && style['global']['actionButton']['borderColor'] ? style['global']['actionButton']['borderColor'] : undefined;
        const actionButtonLabelColor = style && style['global'] && style['global']['actionButton'] && style['global']['actionButton']['labelColor'] ? style['global']['actionButton']['labelColor'] : undefined;
        return (
            <div className='product-view'>
                {this.loadingData() && (
                    <div className='product-view-loader'>
                        <div className='product-view-loader-wrapper'>
                            <DataLoader message='Cargando información del producto...'/>
                        </div>
                    </div>
                )}
                {!this.loadingData() && !this.dataLoaded() && (
                    <React.Fragment>
                        {this.state.notFound ? (
                            <NotFound message={undefined} actionLabel={this.state.errorActionLabel} action={this.state.errorAction} style={this.props.style}/>
                        ) : (
                            <div className='product-view-error'>
                                <div className='product-view-error-wrapper'>
                                    <DataError
                                        message={this.state.errorMessage}
                                        actionLabel={this.state.errorActionLabel}
                                        action={this.state.errorAction}
                                        actionButtonLabelColor={actionButtonLabelColor}
                                        actionButtonBackgroundColor={actionButtonBackgroundColor}
                                        actionButtonBorderColor={actionButtonBorderColor}
                                    />
                                </div>
                            </div>
                        )}
                    </React.Fragment>
                )}
                {!this.loadingData() && this.dataLoaded() && (
                    <React.Fragment>
                        <div className='product-view-content' style={this.contentStyle()}>
                            <div className='product-view-header-wrapper' style={this.listStyle()}>
                                {this.renderTitle()}
                                {showTopGallery && this.renderList(false, 'top')}
                            </div>
                            {!!this.state.selectedImageIndex && (
                                <div className='product-view-viewer' style={this.viewerStyle()}>
                                    {this.state.selectedImageIndex === '3D' && (
                                        <ModelViewer
                                            ref={this._iframeRef}
                                            url={this.buildModelViewerUrl()}
                                            errorActionButtonLabelColor={actionButtonLabelColor}
                                            errorActionButtonBackgroundColor={actionButtonBackgroundColor}
                                            errorActionButtonBorderColor={actionButtonBorderColor}
                                            onLoad={undefined}
                                        />
                                    )}
                                    {this.state.selectedImageIndex !== '3D' && (
                                        <ImageViewer product={this.getImageSource()} selectedImageIndex={this.state.selectedImageIndex}/>
                                    )}
                                </div>
                            )}
                            {!this.state.showProductDetails && !this.state.showVariants && this.renderIconButtonsGrid()}
                            {!showTopGallery && (
                                <div className='product-view-footer-wrapper' style={this.listStyle()}>
                                    {this.renderList(true, 'bottom')}
                                </div>
                            )}
                            {this.state.showArModal && !this.props.showInactivityModal && this.renderArModal()}
                            {this.state.showShareModal && !this.props.showInactivityModal && this.renderShareModal()}
                            {this.state.showExternalProductModal && !this.props.showInactivityModal && this.renderExternalProductModal()}
                            {this.state.showOnRequestProductModal && !this.props.showInactivityModal && this.renderOnRequestProductModal()}
                            {this.state.showNoStockModal && !this.props.showInactivityModal && this.renderNoStockModal()}
                        </div>
                        {this.renderProductDetailsSidebar()}
                        {this.renderProductVariantsSidebar()}
                    </React.Fragment>
                )}
            </div>
        );
    };
}

export default withRouter(Product);

Product.propTypes = {
    params: PropTypes.object,
    client: PropTypes.string,
    instance: PropTypes.object,
    catalog: PropTypes.object,
    store: PropTypes.object,
    session: PropTypes.object,
    style: PropTypes.object,
    inSmallMode: PropTypes.bool,
    showInactivityModal: PropTypes.bool,
    showCheckoutModal: PropTypes.bool,
    openShoppingCart: PropTypes.func,
    addItemToCart: PropTypes.func,
    openActionBar: PropTypes.func,
    closeActionBar: PropTypes.func,
    openActionBarMobile: PropTypes.func,
    closeActionBarMobile: PropTypes.func,
    getMetadata: PropTypes.func
};